import axios from "axios";

/**
 * Report a scraping failure and optionally trigger parsing if menu URL provided
 * @param {Object} reportData - Report data
 * @param {string} reportData.restaurantName - Restaurant name
 * @param {string} reportData.restaurantWebsite - Original website URL
 * @param {string} [reportData.menuUrl] - Direct menu URL (optional)
 * @param {string} [reportData.notes] - Optional notes
 * @param {Object} [reportData.scrapingMetadata] - Metadata about the scraping attempt
 * @returns {Promise<{report: Object, jobId: string|null}>}
 */
export const reportScrapingFailure = async (reportData) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.post(
      "/api/scraping-failures/report",
      reportData,
      config
    );
    return response.data;
  } catch (error) {
    console.error("Error reporting scraping failure:", error);
    throw error;
  }
};




